import React from "react";
import { m, LazyMotion, domAnimation } from "framer-motion";
import clsx from "clsx";

const FullScreenModal: React.FC<{
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  customContentClassName?: string;
  contentClassName?: string;
  actionView?: React.ReactNode;
  customZIndex?: number;
}> = ({
  isOpen,
  onClose,
  children,
  customContentClassName,
  contentClassName = "",
  actionView = null,
  customZIndex,
}) => {
  const backdropVariants = {
    visible: { opacity: 1 },
    hidden: { opacity: 0 },
  };

  const modalVariants = {
    hidden: {
      y: "100dvh",
      // opacity: 0,
    },
    visible: {
      y: 0,
      // opacity: 1,
      transition: { type: "tween", duration: 0.25, ease: "linear" },
    },
    exit: {
      y: "100dvh",
      // opacity: 0,
      transition: { type: "tween", duration: 0.25, ease: "linear" },
    },
  };

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    // Close the modal if the user clicks directly on the backdrop
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  // stop behind scrolling
  if (isOpen) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }

  return (
    <LazyMotion features={domAnimation} strict>
      <m.div>
        {isOpen && (
          <m.div
            className={`fixed inset-0 flex bg-gray-900 bg-opacity-50 z-50 pt-12 ${contentClassName}`}
            style={{
              zIndex: customZIndex || 50,
            }}
            variants={backdropVariants}
            initial="hidden"
            animate="visible"
            exit="hidden"
            onClick={handleBackdropClick}
          >
            <button
              onClick={onClose}
              className="absolute top-4 right-4 text-white hover:text-white/80 z-10 transition-all"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            {actionView}
            <m.div
              className={clsx(
                `full-screen-modal-content bg-[#F9F9F9] rounded-tl-lg rounded-tr-lg shadow-lg w-full relative z-51 h-[100%] md:p-0 p-4 overflow-auto`,
                customContentClassName
              )}
              variants={modalVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
            >
              <div className="h-[calc(100%-35px)]">
                {/* Adjusted height to account for fixed button */}
                {children}
              </div>
            </m.div>
          </m.div>
        )}
      </m.div>
    </LazyMotion>
  );
};

export default FullScreenModal;
